<template>
  <div v-if="godsons.length !== 0">
    <h2 class="text-xs-center primary--text mt-5">
      {{ $t('godfather.godson.title') }}
    </h2>

    <v-data-table v-model="selected"
                  :headers="headers"
                  :items="godsons"
                  hide-actions
                  disable-initial-sort
                  select-all
                  item-key="id"
                  @input="clickRow">
      <template slot="headers"
                slot-scope="props">
        <tr>
          <th width="50px">
            <v-checkbox :input-value="props.all"
                        :indeterminate="props.indeterminate"
                        primary
                        hide-details
                        @click.stop="toggleAll"></v-checkbox>
          </th>
          <th v-for="header in props.headers"
              :key="header.text"
              class="text-xs-left">
            {{ header.text }}
          </th>
        </tr>
      </template>

      <template slot="items"
                slot-scope="props">
        <tr :active="props.selected"
            @click="props.selected = !props.selected">
          <td>
            <v-checkbox :input-value="props.selected"
                        primary
                        hide-details></v-checkbox>
          </td>
          <td class="text-xs-left">{{ props.item.email}}</td>
          <td class="text-xs-left">{{ props.item.registeredAt | formatDatePark}}</td>
          <td class="text-xs-left">{{ props.item.firstReservationAt | formatDatePark}}</td>
        </tr>
      </template>
    </v-data-table>

    <v-layout class="justify-center">
      <v-btn flat
             class="initialize justify-center"
             color="accent"
             outline
             round
             :loading="reminderButtonLoading"
             :disabled="reminderButtonDisabled"
             @click="sendRemind">
        <v-icon class="mr-1"
                small>mail</v-icon>
        {{ $t("godfather.button.remind") }}
      </v-btn>
    </v-layout>
  </div>
</template>

<script>
import godfatherService from '@/services/godfatherService';
import manageErrorService from '@/services/manageErrorService';
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import _ from 'lodash';

export default {
  name: 'Godsons',
  computed: {
    headers() {
      return [
        { text: this.$i18n.t('godfather.table.header.email'), value: 'email', sortable: false },
        { text: this.$i18n.t('godfather.table.header.registeredAt'), value: 'registeredAt', sortable: false },
        { text: this.$i18n.t('godfather.table.header.firstReservationAt'), value: 'firstReservationAt', sortable: false }
      ]
    }
  },
  data: () => ({
    godsons: [],
    selected: [],
    reminderButtonDisabled: true,
    reminderButtonLoading: false
  }),
  async created() {
    this.loadGodsons();
  },
  methods: {
    changeButtonStatus() {
      if (this.selected.length > 0) {
        this.reminderButtonDisabled = false
      } else {
        this.reminderButtonDisabled = true
      }
    },
    clickRow() {
      this.changeButtonStatus()
    },
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.godsons.slice();
      }

      this.changeButtonStatus()
    },
    async sendRemind() {
      this.reminderButtonLoading = true;
      let payload = {};
      payload.friends = _.map(this.selected, 'id').join(',');
      let resp = await godfatherService.remind(payload);

      if (resp.error) {
        manageErrorService.handle(resp.data);
        this.reminderButtonLoading = false;
        return;
      }

      EventBus.$emit(keys.eventOnShowNotification, {
        message: this.$i18n.t('godfather.remind.success'),
        type: 'info',
        doNotTranslate: true
      });

      this.reminderButtonLoading = false;
    },
    async loadGodsons() {
      let resp = await godfatherService.godsons();
      if (resp.error) {
      } else {
        this.godsons = resp.data;
      }
    }
  }
};
</script>